export default __webpack_public_path__ + "static/media/subhero4.86cf0677.jpeg";